module.exports = __webpack_public_path__ + "static/img/program_04.f96466f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/company/program_04.jpg
// module id = VnIe
// module chunks = 0